import { ChangeDetectorRef, Component, Input, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { subMonths } from 'date-fns';
import { DatePickerType } from '../../../../components/ui-elements/date-picker/constants/date-picker-type';
import { DateFilter } from '@lsq-frontend/remote-services/enterprise/common';
import { Utilities } from '../../../../utilities/utilities.helper';
import { BaseFilterComponent } from '../base-filter.component';

@Component({
    selector: 'lsq-date-filter',
    template: `
        <div class="date-filter filter clearfix">
            <form
                [formGroup]="formGroup"
                class="filter-box-date-filter"
                (ngSubmit)="emitFilterUpdate()"
            >
                <lsq-radio-list
                    class="col-12"
                    [formGroup]="formGroup"
                    formControlName="filterOption"
                    name="dateFilterOptions"
                    [vertical]="false"
                    [options]="filterOptions"
                >
                </lsq-radio-list>
                <div>
                    <div class="date-filter-row">
                        <lsq-date-select
                            [hidden]="
                                formGroup.value.filterOption !== filterOptionsValues.after &&
                                formGroup.value.filterOption !== filterOptionsValues.before
                            "
                            id="datepicker"
                            [upperLimit]="today"
                            [type]="datePickerType.Month"
                            [sideBySide]="false"
                            [formGroup]="formGroup"
                            formControlName="date"
                            calendarLabel="Filter Month"
                        >
                        </lsq-date-select>
                        <lsq-date-select
                            [hidden]="formGroup.value.filterOption !== filterOptionsValues.range"
                            id="datepickerRange"
                            [upperLimit]="today"
                            [type]="datePickerType.MonthRange"
                            [sideBySide]="true"
                            [formGroup]="formGroup"
                            formControlName="dateRange"
                            calendarLabel="Filter Range"
                        >
                        </lsq-date-select>
                        <lsq-button class="submit-button" type="submit">
                            Ok
                        </lsq-button>
                    </div>
                </div>
            </form>
        </div>
    `,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./lsq-date-filter.component.scss']
})
export class LsqDateFilterComponent extends BaseFilterComponent {
    @Input() public filter: DateFilter;
    public datePickerType = DatePickerType;
    public today = new Date();
    public threeMonthsAgo = subMonths(new Date(), 3);
    public filterOptionsValues = {
        all: 'all',
        after: 'after',
        before: 'before',
        range: 'range'
    };

    public filterOptions = [
        {
            id: this.filterOptionsValues.all,
            label: 'All Days',
            value: this.filterOptionsValues.all
        },
        {
            id: this.filterOptionsValues.after,
            label: 'After',
            value: this.filterOptionsValues.after
        },
        {
            id: this.filterOptionsValues.before,
            label: 'Before',
            value: this.filterOptionsValues.before
        },
        {
            id: this.filterOptionsValues.range,
            label: 'Range',
            value: this.filterOptionsValues.range
        }
    ];

    constructor(private changeDetectorRef: ChangeDetectorRef) {
        super();
    }

    public setFilterValues(): void {
        let filterOptionValue = this.filterOptionsValues.all;
        let dateValue = this.today;
        let dateRangeValue = [this.threeMonthsAgo, this.today];
        if (this.filter) {
            if (this.filter.toValue && !this.filter.fromValue) {
                dateValue = this.filter.toValue;
                filterOptionValue = this.filterOptionsValues.before;
            }

            if (!this.filter.toValue && this.filter.fromValue) {
                dateValue = this.filter.fromValue;
                filterOptionValue = this.filterOptionsValues.after;
            }

            if (this.filter.toValue && this.filter.fromValue) {
                dateRangeValue = [this.filter.fromValue, this.filter.toValue];
                filterOptionValue = this.filterOptionsValues.range;
            }
        }

        this.formGroup = new FormGroup({
            date: new FormControl(dateValue),
            dateRange: new FormControl(dateRangeValue),
            filterOption: new FormControl(filterOptionValue)
        });
        Utilities.executeAfterRender(() => this.changeDetectorRef.markForCheck());
    }

    public createFormGroup(): FormGroup {
        return new FormGroup({
            date: new FormControl(this.today),
            dateRange: new FormControl([this.threeMonthsAgo, this.today]),
            filterOption: new FormControl(this.filterOptionsValues.all)
        });
    }

    public emitFilterUpdate(): void {
        let fromValue: Date = null;
        let toValue: Date = null;

        if (this.formGroup.value.filterOption === this.filterOptionsValues.after) {
            fromValue = this.formGroup.value.date;
        }

        if (this.formGroup.value.filterOption === this.filterOptionsValues.before) {
            toValue = this.formGroup.value.date;
        }

        if (this.formGroup.value.filterOption === this.filterOptionsValues.range) {
            fromValue = this.formGroup.value.dateRange[0];
            toValue = this.formGroup.value.dateRange[1];
        }

        const filterData = { [this.column.filterField]: new DateFilter({ fromValue, toValue }) };
        this.updated.emit(filterData);
    }
}
